var exports = {
  "k": "x8b4e8595--ab854d--container",
};

module.exports = exports;
